import {
  BaseQueryFn,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';

const urlPrefix = process.env.API_URL ?? '';
const baseQueryWithAuth = (
  baseUrls: '/life' | '/agent' | '/payment' | '/admin' | '/affiliate',
): BaseQueryFn => {
  return async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({ baseUrl: urlPrefix + baseUrls });
    const baseQueryToken = fetchBaseQuery({ baseUrl: urlPrefix + '/token' });

    // Fetch the JWT token
    const body = JSON.stringify(
      args.body?.refId ?? args.body ?? args.params?.refId ?? args.params,
    );
    const jwtTokenResponse = await baseQueryToken(
      {
        url: '/generate-payload',
        method: 'POST',
        body: {
          payload: body,
        },
      },
      api,
      extraOptions,
    );

    if (jwtTokenResponse) {
      const jwtToken = (jwtTokenResponse.data as { payload: string }).payload;

      // Add the CSRF token to headers for subsequent requests
      const headers = {
        Authorization: `Bearer ${jwtToken}`,
        Accept: 'application/json',
        ...extraOptions, // Preserve any additional headers
      };

      // Proceed with the original request using updated headers
      return baseQuery(
        {
          ...args,
          headers,
        },
        api,
        extraOptions,
      );
    }

    // If the token fetch fails, return an error
    return {
      error: {
        status: 403,
        message: 'Unable to fetch JWT token',
      },
    };
  };
};

export const lifeApi = createApi({
  reducerPath: 'lifeApi',
  baseQuery: baseQueryWithAuth('/life'),
  endpoints: () => ({}),
});

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: baseQueryWithAuth('/admin'),
  endpoints: () => ({}),
});

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: baseQueryWithAuth('/payment'),
  endpoints: () => ({}),
});

export const agentApi = createApi({
  reducerPath: 'agentApi',
  baseQuery: baseQueryWithAuth('/agent'),
  endpoints: () => ({}),
});

export const affiliateApi = createApi({
  reducerPath: 'affiliateApi',
  baseQuery: baseQueryWithAuth('/affiliate'),
  endpoints: () => ({}),
});

export const tokenApi = createApi({
  reducerPath: 'tokenApi',
  baseQuery: fetchBaseQuery({
    baseUrl: urlPrefix + '/token',
  }),
  endpoints: () => ({}),
});
